import { render, staticRenderFns } from "./bounce-block-setting.vue?vue&type=template&id=11c96c3f"
import script from "./bounce-block-setting.vue?vue&type=script&lang=js"
export * from "./bounce-block-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports